// TODO: Should be actually LanguageCode
export type CountryCode =
  | 'pl_PL'
  | 'pl'
  | 'en'
  | 'de'
  | 'it'
  | 'es'
  | 'ru'
  | 'se'
  | 'hu'
  | 'cz'
  | 'bg'
  | 'pt_BR'
  | 'pt'
  | 'tr'
  | 'fr'
  | 'hr'
  | 'el'
  | 'fil'
  | 'ja'
  | 'ko'
  | 'ms'
  | 'th'
  | 'ro'
  | 'in'
  | 'uk'

export const countryCodes: CountryCode[] = [
  'bg',
  'cz',
  'en',
  'de',
  'es',
  'fr',
  'hr',
  'hu',
  'it',
  'pl',
  'pt_BR',
  'pt',
  'ru',
  'se',
  'tr',
  'el',
  'fil',
  'ja',
  'ko',
  'ms',
  'th',
  'ro',
  'in',
  'uk',
]

export function asCountryCode(languageCode: CountryCode): string {
  const chunks = languageCode.split('_')
  return chunks[chunks.length - 1]
}

export async function getCountryFlag(
  countryCode: CountryCode | string | unknown,
): Promise<string> {
  const objectWithSrc: IString = await import(
    `../assets/flags/${countryCode}.svg`
    )

  return objectWithSrc.default
}

interface IString {
  default: string
}
